var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeclose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.78 468.3a180.55 180.55 0 01149.58-149.58l89-89a487.09 487.09 0 00-60.36-3.84C208.56 225.88 0 512 0 512s53.22 72.93 144.92 145.16zM862 353.78L690.22 525.6a180.54 180.54 0 01-149.56 149.56L425.51 790.31a491.54 491.54 0 0086.49 7.81c303.44 0 512-286.12 512-286.12s-59.84-82-162-158.22zM117.594 802.967L802.972 117.59 906.4 221.018 221.023 906.396z"
  })));
}
export default SvgEyeclose;